import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-empanada/issue-navigator-placement';

import { IssuePreviewPanelChangeboardingTour } from '../../../components/IssuePreviewPanelChangeboardingTour';

import { IssuePreviewPanelSpotlight } from '../../../components/IssuePreviewPanelSpotlight';

import { type MessageTemplateContext } from '../../../index';

/**
 * The placement API drops `context` on the way out and merges the template context into the message
 * itself — see `PlacementMessagesResponse`, which is
 * `Array<Omit<EligibleMessage, 'context'> & THydratedData>`. So the variant the implicit creator
 * chose arrives spread across the render props, not nested. `EligibleMessage.context` only exists
 * server side, inside the pipeline.
 */
type RenderProps = PlacementRenderProps & MessageTemplateContext;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: (props: RenderProps) => {
			if (!('placementType' in props)) {
				return null;
			}

			// Absent or anything other than 'tour' renders v1 unchanged — the GA experiment being off is
			// the tour's kill-switch, and a context written before the variant existed must land here too.
			if (props.variant === 'tour') {
				return <IssuePreviewPanelChangeboardingTour {...props} />;
			}

			return <IssuePreviewPanelSpotlight {...props} />;
		},
	},
});
